module.exports = __webpack_public_path__ + "img/9788954619066.70690330.jpg";